module.exports = __webpack_public_path__ + "img/logo-quac-morado.22e85939.svg";